module.exports = __webpack_public_path__ + "static/family-4d44f2e0b8b986d2a5bfded90777ae43.svg";